export default {
  redeemCode: {
    title: 'कोड रिडीम करें',
    description: 'अपना इनाम पाने के लिए नीचे अपना रिडीम कोड दर्ज करें।',
    enterTip: 'पुरस्कार प्राप्त करने के लिए अपना रिडीम कोड दर्ज करें',
    label: 'रिडीम कोड',
    placeholder: 'रिडीम कोड दर्ज करें',
    submit: 'रिडीम करें',
    redeemBtn: 'रिडीम करें',
    submitting: 'रिडीम हो रहा है...',
    success: 'कोड सफलतापूर्वक रिडीम हो गया!',
    redeemSuccess: 'कोड सफलतापूर्वक रिडीम हो गया!',
    failed: 'कोड रिडीम करने में विफल, कृपया पुनः प्रयास करें।',
    redeemFailed: 'कोड रिडीम करने में विफल, कृपया पुनः प्रयास करें।'
  }
};
